interface SettingsPageHeaderProps {
  title: string;
  description?: string;
}

export const SettingsPageHeader = ({
  title,
  description,
}: SettingsPageHeaderProps) => (
  <header>
    <h1 className="m-0 text-xl font-medium tracking-[-0.01em] text-black-heading">
      {title}
    </h1>
    {description && (
      <p className="mt-1 mb-0 text-base text-secondary">{description}</p>
    )}
  </header>
);
